import React from 'react';
import { Empty, Tooltip } from '@maxtropy/components';
import styles from './index.module.scss';
import { getWeatherOption } from '../../chartOptions';
import { Point } from '../../type';
import ChartBlock from '../ChartBlock';
import SectionPanel from '../SectionPanel';

interface WeatherPanelProps {
  weather: {
    cards: { commStatusText?: string; isCommAbnormal?: boolean; label: string; unit?: string; value: string }[];
    ghi: Point[];
    temperature: Point[];
  };
}

const WeatherPanel: React.FC<WeatherPanelProps> = ({ weather }) => {
  const hasChartData = weather.ghi.length > 0 || weather.temperature.length > 0;

  return (
    <SectionPanel title="气象站实时数据" bodyClassName={styles.panelBody}>
      <div className={styles.weatherMetrics}>
        {weather.cards.map(item => (
          <div className={styles.weatherMetricCard} key={item.label}>
            <span className={styles.weatherMetricLabel}>
              {item.label}
              <Tooltip title={item.commStatusText}>
                <span
                  className={`${styles.weatherMetricStatusDot} ${
                    item.isCommAbnormal ? styles.weatherMetricStatusDotError : ''
                  }`}
                />
              </Tooltip>
            </span>
            <span className={styles.weatherMetricValue}>
              <span className={styles.weatherMetricValueText}>{item.value}</span>
              {item.unit && <span className={styles.weatherMetricUnit}>{item.unit}</span>}
            </span>
          </div>
        ))}
      </div>
      {hasChartData ? (
        <ChartBlock option={getWeatherOption(weather.ghi, weather.temperature)} height={294} />
      ) : (
        <Empty className={styles.empty} description="暂无数据" />
      )}
    </SectionPanel>
  );
};

export default WeatherPanel;
